<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}个{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" type="danger" size="small" :disabled="multiple"
            v-preventReClick @click="handleDelete">
            删除
          </el-button>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>
      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight"
        style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column fixed :reserve-selection="true" type="selection" width="55" align="center"></el-table-column>
        <el-table-column fixed prop="no" label="编号">
          <template slot-scope="scope">
            <span>
              <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column fixed prop="name" label="名称"></el-table-column>
        <el-table-column prop="parentName" label="主柜">
          <template slot-scope="scope">
            {{ scope.row.parentName?scope.row.parentName:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="category" label="柜子类型">
          <template slot-scope="scope">
            {{scope.row.category=='1'?'安卓':'Windows'}}
          </template>
        </el-table-column>
        <el-table-column prop="deptName" label="科室"></el-table-column>
        <el-table-column prop="ip" label="Ip">
          <template slot-scope="scope">
            {{ scope.row.ip?scope.row.ip:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="stateName" label="状态"></el-table-column>
        <el-table-column prop="createdTime" label="创建时间">
          <template slot-scope="scope">
            <div>
              {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d}") }}
            </div>
            <div>
              {{ parseTime(new Date(scope.row.createdTime), "{h}:{i}:{s}") }}
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="operation" fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
            <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick
              @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick
              @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
                <el-button v-if="tableAcl.indexOf('InventoryCalibration') != -1&&scope.row.category=='1'" type="text" v-preventReClick
              @click="inventoryCalibration(scope.row)" class="margin-left20 color-blue">库存校准</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :title="title + route.menuName" :visible.sync="open" :center="true" width="1100px"
        :before-close="cancel" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
          <el-row>
            <el-col :span="12">
              <el-form-item prop="no" label="编号">
                <el-input v-model="form.no" :disabled="!editMode" placeholder="请输入编号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="name" label="名称">
                <el-input v-model="form.name" :disabled="!editMode" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="parentName" label="主柜">
                <el-select v-model="form.parentName" :disabled="!editMode" filterable
                  :filter-method="getIntelligenceCounters" placeholder="请选择主柜" @change="parentChange"
                  style="width: 100%">
                  <el-option v-for="item in STATIC_IntelligenceCounters" :key="item.id"
                    :label="item.no + ' ' + item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="deptId" label="科室">
                <el-select v-model="form.deptName" :disabled="!editMode" filterable :filter-method="getDepts"
                  placeholder="请选择科室" @change="deptChange" style="width: 100%">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="ip" label="Ip">
                <el-input v-model="form.ip" :disabled="!editMode" placeholder="请输入Ip"></el-input>
              </el-form-item>
            </el-col>
              <el-col :span="12">
                    <el-form-item prop="category" label="柜子类型">
                        <el-select v-model="form.category" :disabled="!editMode" filterable :filter-method="getDepts"
                          placeholder="请选择科室"  style="width: 100%">
                          <el-option label="Windows" :value="0"></el-option>
                             <el-option label="安卓" :value="1"></el-option>
                        </el-select>
                    </el-form-item>
              </el-col>
            </el-row>
            <el-row>
            <el-col :span="12">
              <el-form-item label="启用">
                <el-switch v-model="form.state" :disabled="!editMode" active-color="#286AB4" inactive-color="#D4D4D4"
                  :active-value="1" :inactive-value="0" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
          <el-button class="btn primary" type="primary" v-if="editMode" size="small" v-preventReClick @click="submit">确
            定</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  GetIntelligenceCounters,
  RemoveIntelligenceCounter,
  GetIntelligenceCounterById,
  SaveIntelligenceCounter,
  RefreshNewCabinetStock,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    // SelectTree
  },
  data() {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      editMode: false,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        no: [{ required: true, message: "请输入编号", trigger: "blur" }],
        deptId: [{ required: true, message: "请选择科室", trigger: "blur" }],
        category: [{ required: true, message: "请选择柜子类型", trigger: "blur" }],
      },
    };
  },
  methods: {
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    // 获取列表
    getData() {
      GetIntelligenceCounters(this.query)
        .then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 新建
    handleAdd() {
      this.open = true;
      this.title = "新建";
      this.resetForm();
      this.editMode = true;
    },
    handleInfo(row) {
      GetIntelligenceCounterById({ id: row.id }).then((res) => {
        this.resetForm();
        this.form = res.returnData;
        this.open = true;
        this.editMode = false;
      });
    },
    // 编辑
    handleUpdate(row) {
      GetIntelligenceCounterById({ id: row.id }).then((res) => {
        this.resetForm();
        this.form = res.returnData;
        this.open = true;
        this.title = "编辑";
        this.editMode = true;
      });
    },
    // 保存
    submit() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveIntelligenceCounter(this.form)
          .then((res) => {
            this.open = false;
            this.$my_message(`执行成功`, "success");
            this.getData();
          })
          .finally(() => {
            this.$store.dispatch('SetLoading', false)
          });
      });
    },
    resetForm() {
      this.form = {
        id: 0,
        name: "",
        no: "",
        orgCode :sessionStorage.getItem('orgId')
      };
    },
    // 取消编辑
    cancel() {
      this.$store.dispatch('SetLoading', false)
      if (this.editMode) {
        this.$my_confirm("确认要中断当前操作吗？", "提示", {
          type: "warning",
        })
          .then(() => {
            this.open = false;
          })
          .catch(() => { });
      } else {
        this.open = false;
      }
    },
    // 改变当前页
    changePage(val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 删除部门
    handleDelete(row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("此操作将删除数据, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          return RemoveIntelligenceCounter({ ids });
        })
        .then(() => {
          this.$my_message(`删除成功`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset() {
      this.query.keyWord = "";
      this.$set(this.query, "pageIndex", 1);
      this.$set(this.query, "pageSize", 10);
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.loading = true;
      this.getData();
    },
    queryChange() {
      this.$set(this.query, "pageIndex", 1);
      this.loading = true;
      this.getData();
    },

    parentChange(val) {
      this.form.parentid = val;
    },
    deptChange(val) {
      this.form.deptId = val;
    },

    inventoryCalibration(row) {
      if(!row.ip){
        this.$my_message(`请先配置智能IP`, "warning");
        return;
      }
      RefreshNewCabinetStock({ cabinetIp: row.ip }).then((res) => {
         this.getData();
        this.$my_message(`校准成功`, "success");
      });
    },
  },
  mounted() {
    this.getData();
    this.getIntelligenceCounters("");
    this.getDepts("");
  },
};
</script>

<style lang="scss" scoped></style>
